import { render, staticRenderFns } from "./navigation-drawer.vue?vue&type=template&id=81193b50&scoped=true"
import script from "./navigation-drawer.vue?vue&type=script&lang=js"
export * from "./navigation-drawer.vue?vue&type=script&lang=js"
import style0 from "./navigation-drawer.vue?vue&type=style&index=0&id=81193b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81193b50",
  null
  
)

export default component.exports